import * as React from "react"
import MuiGrid from "@mui/material/Grid"

export default function Grid(props: any) {
  return <MuiGrid {...props} />
}
